import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/seo/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <Seo
        title="页面未找到 | 蝌蚪爆料"
        description="你访问的页面不存在或已被调整，可以回到蝌蚪爆料首页或最新爆料列表继续浏览现场线索。"
        keywords="蝌蚪爆料,页面未找到,蝌蚪爆料导航"
        path={location.pathname}
      />
      <section className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-center px-4 py-24 text-center md:px-8 md:py-32">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
          <i className="ri-compass-3-line text-3xl" />
        </span>
        <p className="mt-6 font-heading text-5xl font-black text-primary-200 md:text-7xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          这个页面好像被撤下了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的地址不存在，也可能对应的内容已经调整。回到首页或最新爆料列表，继续看正在更新的现场线索。
        </p>
        <p className="mt-2 text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/feed"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            浏览最新爆料
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}